import { memo } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { CIVILITY } from "app/constants";
import { FormikSelectField } from "app/components/form/FormikSelectField/FormikSelectField";
import { FormikTextField } from "app/components/form/FormikTextField/FormikTextField";
import "./IdentityFieldset.scss";

const IdentityFieldset = ({ isRequired, blocPrefixName = "" }) => {
	return (
		<div className="identity">
			<div className="identity__gender identity__item identity__radio">
				<FormikSelectField
					id="honorific-prefix"
					name={
						blocPrefixName
							? `${blocPrefixName.toLowerCase()}.honorific-prefix`
							: "honorific-prefix"
					}
					isRequired={isRequired}
					label={<FormattedMessage id="identity.gender.label" />}
					data-testid="gender-select-input"
					className="identity__gender-select"
				>
					<option />
					{[CIVILITY.MALE, CIVILITY.FEMALE].map(gender => (
						<FormattedMessage
							key={gender}
							id={`general.gender.${gender.toLowerCase()}`}
						>
							{message => (
								<option key={gender} value={gender}>
									{message}
								</option>
							)}
						</FormattedMessage>
					))}
				</FormikSelectField>
			</div>
			<div className="identity__firstname identity__item identity__input">
				<FormikTextField
					id="given-name"
					name={
						blocPrefixName ? `${blocPrefixName.toLowerCase()}.given-name` : "given-name"
					}
					isRequired={isRequired}
					label={<FormattedMessage id="identity.firstname.label" />}
					maxLength={30}
					data-testid="given-name-input"
				/>
			</div>

			<div className="identity__lastname identity__item identity__input">
				<FormikTextField
					id="family-name"
					name={
						blocPrefixName
							? `${blocPrefixName.toLowerCase()}.family-name`
							: "family-name"
					}
					isRequired={isRequired}
					label={<FormattedMessage id="identity.lastname.label.full" />}
					maxLength={30}
					data-testid="family-name-input"
				/>
			</div>
		</div>
	);
};

IdentityFieldset.propTypes = {
	isRequired: PropTypes.bool,
	blocPrefixName: PropTypes.string,
};

export default memo(IdentityFieldset);
